import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-3" }

import { InputRow, DatePicker, Combobox } from '@/components/ui/form';
    import { computed } from 'vue';
    import type { SelectOption } from '@/types';
    import { useTaskTemplateData } from '@/composables/useTaskTemplateData';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'TaskFromTemplateForm',
  props: {
    form: {}
  },
  setup(__props: any) {

    const props = __props;

    const { taskTemplates, isTaskTemplatesPending } = useTaskTemplateData();

    const templateOptions = computed<SelectOption[]>(() => {
        return Object.entries(taskTemplates.value).map(([value, label]) => ({
            value,
            label: label as string,
        }));
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "selected_template",
      label: "dashboards.selected_template"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Combobox), {
          modelValue: _ctx.form.selected_template,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.selected_template) = $event)),
          options: templateOptions.value,
          "show-remove-button": false,
          loading: _unref(isTaskTemplatesPending)
        }, null, 8, ["modelValue", "options", "loading"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "tasks_deadline",
      label: "dashboards.tasks_deadline"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DatePicker), {
          modelValue: _ctx.form.tasks_deadline,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.tasks_deadline) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["form"])
  ]))
}
}

})